var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result"},[_c('Results',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("submitSuccess"))+" ")]},proxy:true},{key:"label",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("officeResultLabel"))+" ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }